const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import NodePoolUiil from "../../../longhudou/module/node_pool_util"
import UserDataManager from "../../../../manager/user_manager";
import ModelData, { IUserData } from '../../../public/model_data';
import { pseudoRandomBytes } from "crypto";
import Util from "../../../longhudou/module/util";
import GameUtil from "../../../../utility/game_util"
import Utility from "../../../../utility/utility";
import roadmap from "../../../public/roadmap";
import LanguageManager from "../../../../manager/language_manager";
import EffectCtr, { EffectName } from "../effect_yxx_ctr"
import TableSound from "../sound_yxx_ctr"
import EventManager from "../../../../manager/event_manager";
import TableBaseView from "../../../table/module/table_base/table_base_view";

@ccclass
export default abstract class YXXTableViewBase extends TableBaseView {

    @property(cc.Node)
    clockNode: cc.Node = null

    @property(cc.Label)
    clockLab: cc.Label = null

    @property(cc.Node)
    jettonChoose: cc.Node = null

    @property(cc.SpriteAtlas)
    jettonAtlas: cc.SpriteAtlas = null

    @property(cc.Node)
    resultNode: cc.Node = null

    @property(cc.Sprite)
    result: cc.Sprite[] = []

    @property(cc.SpriteFrame)
    resultFrame: cc.SpriteFrame[] = []

    @property(cc.Node)
    bankerNode: cc.Node = null

    @property(cc.Node)
    autoGou: cc.Node = null

    @property(cc.Node)
    winLoseNode: cc.Node = null

    @property(cc.Node)
    winEffectNode: cc.Node = null

    @property(cc.Node)
    loseEffectNode: cc.Node = null

    @property(cc.Sprite)
    winLoseHead: cc.Sprite = null

    @property(cc.Label)
    winLoseId: cc.Label = null

    @property(cc.Label)
    winCount: cc.Label = null

    @property(cc.Label)
    loseCount: cc.Label = null

    @property(cc.Label)
    caichiNumLab: cc.Label = null


    @property(EffectCtr)
    effectCtr: EffectCtr = null

    @property(cc.Button)
    autoBetBtn: cc.Button = null

    @property(cc.Sprite)
    autoBetBtnSpr: cc.Sprite = null

    @property(cc.Button)
    isAutoBetBtn: cc.Button = null

    @property(cc.Sprite)
    myGoldSpr: cc.Sprite = null

    @property(cc.SpriteFrame)
    goldTypeSpr: cc.SpriteFrame[] = []

    @property(cc.Node)
    betObj: cc.Node = null

    @property(cc.Node)
    betOther: cc.Node = null

    @property(cc.SpriteFrame)
    goldSpr: cc.SpriteFrame = null

    @property(cc.Node)
    betBtnNode: cc.Node = null

    //上下庄相关的
    @property(cc.Node)
    banker: cc.Node = null

    @property(cc.Node)
    sysBanker: cc.Node = null

    @property(cc.Node)
    sysYiZi: cc.Node = null

    @property(cc.Node)
    goBankerBtn: cc.Node = null

    @property(cc.Node)
    closeGoBankerBtn: cc.Node = null

    @property(cc.Sprite)
    bankerHead: cc.Sprite = null

    @property(cc.Label)
    bankerName: cc.Label = null

    @property(cc.Label)
    bankerRound: cc.Label = null

    @property(cc.Label)
    bankerGold: cc.Label = null

    @property(cc.Node)
    tipsBankerNode: cc.Node = null

    @property(cc.Label)
    tipsBankerName: cc.Label = null

    @property(cc.Sprite)
    tipsBankerIcon: cc.Sprite = null

    @property(cc.Animation)
    bankerWinLose: cc.Animation = null

    @property(cc.Label)
    bankerWinLab: cc.Label = null

    @property(cc.Label)
    bankerLoseLab: cc.Label = null

    lastBankerId = null

    tableSound: TableSound = new TableSound()
    jettonPool: NodePoolUiil = null

    betArea: any[] = []
    betCounts: any[] = []//总得押注数量
    jettonItemBtns: any[] = [] //押注按钮数据
    betjettons = [] //显示得筹码
    playerItems = [] //玩家信息
    winJettonsById = [] //赢取的筹码 
    isShowPlayerIndex = []
    isShowPlay = []
    jettonDatas = null //所有的筹码
    winLoseY = 30 //输赢飘字位移
    betDataByIndex = [] //本地押注数据
    startPosById = [] //玩家下注得节点
    btnNodeByBetType = {}
    caiChiPos = null //彩池筹码节点

    isTb = false //是否为骰宝游戏
    isFreeGame = false //是否芒果场

    curChooseJetton = null //当前选择的
    betTypeByIndex = null
    onLoad() {
        super.onLoad()
        this.initRankPlayerInfo()
        this.effectCtr.playEffectAnim(EffectName.HeGuan, null, true)
    }

    get selfPosIndex(): number {
        return 8
    }

    get othersPosIndex(): number {
        return 7
    }

    //初始化下注区域
    initBetArea(betNameList) {
        if (betNameList == null) { return }
        for (let index = 0; index < betNameList.length; index++) {
            const betName = betNameList[index].toString();
            let obj = cc.find("BetArea/" + betName, this.node)
            if (obj != null) {
                let countNode = cc.find("BetArea/TipsBet/" + betName + "/CountNode", this.node)
                let countLab = cc.find("Number", countNode).getComponent(cc.Label)
                let resultObj = cc.find("BetArea/TipsBet/" + betName + "/Win", this.node)
                let resultAmin = null
                if (resultObj != null) {
                    resultAmin = resultObj.getComponent(cc.Animation)
                }
                this.betArea[betName] = { Obj: obj, CountNode: countNode, ResultObj: resultAmin, CountLab: countLab }
                this.betCounts[betName] = 0
            }
        }
    }

    //初始化下注按钮
    initBetBtn(jettonDatas, isFree) {

        this.jettonPool = this.node.getComponent(NodePoolUiil)
        this.jettonPool.initNodePool(400) //初始化筹码对象池
        let chooseobj = null
        this.btnNodeByBetType = {}
        this.isFreeGame = isFree
        let jettonParent = isFree ? this.betOther : this.betObj
        this.betOther.active = isFree
        this.betTypeByIndex = []
        this.betObj.active = !isFree
        for (let index = 0; index < 5; index++) {
            let objName = (index + 1).toString()
            const obj = cc.find(objName, jettonParent)
            const count = jettonDatas[index]
            // if (!isFree){
            //     let spr = obj.getComponent(cc.Sprite)
            //     spr.spriteFrame = this.jettonAtlas.getSpriteFrame("public_bet_" + count)
            // }
            // else{
            let countLab = cc.find("Count", obj).getComponent(cc.Label)
            countLab.string = isFree ? GameUtil.currencyFormatting(count, 2, true) :
                (GameUtil.currencyFormatting(count, 2, true)).replace(".", "&")
            //}
            let mask = cc.find("Mask", obj)
            let maskEvent = null
            if (mask != null) {
                maskEvent = mask.getComponent(cc.BlockInputEvents)
            }
            if (chooseobj == null) { chooseobj = obj }
            this.betTypeByIndex[count] = index
            this.btnNodeByBetType[count] = obj
            this.jettonItemBtns[objName] = { BtnObj: obj.getComponent(cc.Button), Count: count, Mask: maskEvent }
        }

        this.jettonDatas = jettonDatas
        this.showChooseJetton(chooseobj)
    }

    initRankPlayerInfo() {

        for (let index = 0; index < this.selfPosIndex; index++) {
            let itemObj = cc.find("Centre/Players/Player" + (index + 1), this.node)
            let noplayer = cc.find("NoPlayer", itemObj)
            let playerInfo = cc.find("Centre/Players/PlayerInfo" + (index + 1), this.node)
            let nameLab = cc.find("LabNode/Name" + (index + 1), this.node).getComponent(cc.Label)
            let iconSpr = cc.find("IconBg/Icon", playerInfo).getComponent(cc.Sprite)
            let moneyLab = cc.find("LabNode/GoldCount" + (index + 1), this.node).getComponent(cc.Label)
            let winLab = cc.find("WinLose/shuzi/Count", itemObj).getComponent(cc.Label)
            let winAmin = cc.find("WinLose", itemObj).getComponent(cc.Animation)
            let startPos = cc.find("BetArea/StartPos" + (index + 1), this.node)
            this.playerItems[index] = { Obj: itemObj, StartPos: startPos, Name: nameLab, Icon: iconSpr, Money: moneyLab, Win: winLab, WinAmin: winAmin, PlayerInfo: playerInfo, NoPlayer: noplayer }
        }

        let myselfObj = cc.find("Bottom/Player", this.node) //PlayerBg
        let nameLab = cc.find("ID", myselfObj).getComponent(cc.Label)
        let iconSpr = cc.find("Head/Mask/HeadImage", myselfObj).getComponent(cc.Sprite)
        let moneyLab = cc.find("GoldCount", myselfObj).getComponent(cc.Label)
        let winLab = cc.find("WinLose/shuzi/Count", myselfObj).getComponent(cc.Label)
        let winAmin = cc.find("WinLose", myselfObj).getComponent(cc.Animation)
        let startPos = cc.find("BetArea/StartPos0", this.node)
        this.playerItems[this.selfPosIndex] = { Obj: myselfObj, StartPos: startPos, Name: nameLab, Icon: iconSpr, Money: moneyLab, Win: winLab, WinAmin: winAmin, PlayerInfo: null, NoPlayer: null }
        this.caiChiPos = cc.find("BetArea/StartPos10", this.node)
    }


    //刷新下注区域显示数据
    refreshBetArea(totleData: any, mySelfData: any, isForced: boolean = false) {
        for (const data of mySelfData) {
            if (this.betCounts[data.area] <= data.amount || isForced) {
                this.betCounts[data.area] = data.amount
            }
            if (this.betCounts[data.area] != null && this.betCounts[data.area] > 0) {
                this.betArea[data.area].CountLab.string = GameUtil.currencyFormatting(this.betCounts[data.area])
                this.betArea[data.area].CountNode.active = true
            }
        }

    }

    //显示开奖结果
    showResulet(resuletData: any, m_callback: Function, isAmin: boolean = true) {

    }

    showReady() {

    }

    //下注提示
    showBetTips(isStart: boolean) {
        let self = this
        if (isStart) {
            this.effectCtr.playEffectAnim(EffectName.StartBet)
        }
        else {
            this.effectCtr.playEffectAnim(EffectName.EndBet)
        }
        self.tableSound.playStartOrBetBet(isStart)
    }

    playDaoJiShi() {
        this.effectCtr.playEffectAnim(EffectName.NaoZhong)
        this.tableSound.playTimeSound()
    }


    //更新筹码遮罩
    updateJettonMask(balance, isMask) {
        let isAllMask = true
        for (const key in this.jettonItemBtns) {
            if (this.jettonItemBtns.hasOwnProperty(key)) {
                const element = this.jettonItemBtns[key];
                let isGray = element.Count > balance
                Utility.setBtnGray(element.BtnObj, isGray)
                if (!isGray || isMask) {
                    if (element.Mask != null) {
                        element.Mask.enabled = isMask
                        element.Mask.node.opacity = isMask ? 255 : 0
                    }
                    if (isAllMask) { isAllMask = false }
                }
            }
        }
        this.showChooseJetton((isMask || isAllMask) ? null : this.curChooseJetton)
    }

    //选择筹码
    showChooseJetton(obj: cc.Node) {
        for (const key in this.jettonItemBtns) {
            if (this.jettonItemBtns.hasOwnProperty(key)) {
                const element = this.jettonItemBtns[key];
                if (obj == element.BtnObj.node) {
                    element.BtnObj.node.setPosition(new cc.Vec2(obj.position.x, 22))
                    this.curChooseJetton = obj
                }
                else {
                    element.BtnObj.node.setPosition(new cc.Vec2(element.BtnObj.node.position.x, 0))
                }
            }
        }
        if (!this.isFreeGame && obj != null) {
            this.jettonChoose.position = obj.position
            this.jettonChoose.active = true
        }
        else {
            this.jettonChoose.active = false
        }
    }

    refreshPlayerCoinBalance(playerId, coinBalance) {
        let balance = GameUtil.currencyFormatting(Number(coinBalance))
        if (this.lastBankerId == playerId) {
            this.bankerGold.string = balance
        } else {
            for (let index = 0; index < this.playerItems.length; index++) {
                const item = this.playerItems[index];
                if (item.Id == playerId) {
                    item.Money.string = balance
                }
            }
        }
    }

    updatePlayerInfo(playerData: any, isUpdate, isMySelf) {

        let self = this
        let playerObjIndex = 0
        if (playerData.richRank == 0) {
            playerObjIndex = this.selfPosIndex
        }
        else {
            playerObjIndex = playerData.richRank - 1
        }

        if (this.playerItems[playerObjIndex] == null) { return }

        if (this.playerItems[playerObjIndex].PlayerInfo != null) {
            this.playerItems[playerObjIndex].PlayerInfo.active = true
            this.playerItems[playerObjIndex].NoPlayer.active = false
        }
        UserDataManager.setUserJsonData(playerData.userData)
        self.getUserData(playerData.id, (data: IUserData) => {
            function _showUserData() {
                self.playerItems[playerObjIndex].Name.string = GameUtil.cutStr(data.name)
                self.playerItems[playerObjIndex].Icon.spriteFrame = data.avatarSprite
            }
            //排行榜玩家变更 需要改变
            if (self.playerItems[playerObjIndex].Id != null && playerObjIndex != self.selfPosIndex) {
                if (self.playerItems[playerObjIndex].Id != playerData.id) {
                    self.playerItems[playerObjIndex].Name.string = ""
                    self.changeHeadActon(this.playerItems[playerObjIndex].Icon, _showUserData)
                } else {
                    _showUserData()
                }
            }
            else {
                _showUserData()
            }
            self.playerItems[playerObjIndex].Id = playerData.id

        })

        if (playerData.winLoss != null && playerData.winLoss != "") {
            let winNum = Number(playerData.winLoss)
            self.scheduleOnce(function () {
                if (winNum > 0) {
                    //存好要飘筹码得数据
                    if (self.winJettonsById[playerData.id] == null) {
                        self.winJettonsById[playerData.id] = self.getCurrentJettons(Math.ceil(winNum), null, this.betjettons)
                        self.startPosById[playerData.id] = self.playerItems[isMySelf ? self.selfPosIndex : playerObjIndex].StartPos
                    }
                }

            }, 1.3)
            self.scheduleOnce(function () {
                self.playerItems[playerObjIndex].Money.string = GameUtil.currencyFormatting(Number(playerData.balance))
                if (Number(playerData.actualWinLoss) > 0) {
                    let winStr = "+" + GameUtil.currencyFormatting(Number(playerData.actualWinLoss))
                    self.playerItems[playerObjIndex].Win.string = winStr
                    self.playerItems[playerObjIndex].WinAmin.play()
                }
            }, 2.5)

            self.scheduleOnce(function () {
                if (playerObjIndex == self.selfPosIndex) {
                    self.showSelfResultCount(playerData)
                }
            }, 4)
        }

        else {
            //角色得信息
            if (isUpdate) {
                self.playerItems[playerObjIndex].Money.string = GameUtil.currencyFormatting(Number(playerData.balance))
            }

        }
        this.isShowPlayerIndex[playerObjIndex] = { Id: playerData.id, Obj: this.playerItems[playerObjIndex].StartPos, Money: self.playerItems[playerObjIndex].Money, isMySelf: isMySelf }
    }

    showSelfResultCount(playerData) {
        let self = this
        this.getUserData(playerData.id, (data: IUserData) => {
            this.winLoseId.string = GameUtil.cutStr(data.name)
            this.winLoseHead.spriteFrame = data.avatarSprite
        })
        this.tableSound.playResult(Number(playerData.actualWinLoss) > 0)
        this.winLoseNode.active = true
        let str = null
        if (Number(playerData.actualWinLoss) > 0) {
            this.loseCount.string = ""
            str = "+" + GameUtil.currencyFormatting(Number(playerData.actualWinLoss))
            this.winCount.string = str
            this.winLoseNode.parent = this.winEffectNode
            this.winEffectNode.active = true
            this.effectCtr.playEffectAnim(EffectName.SelfWin)
        }
        else {
            this.winCount.string = ""
            str = GameUtil.currencyFormatting(Number(playerData.actualWinLoss))
            this.loseCount.string = str
            this.winLoseNode.parent = this.loseEffectNode
            this.loseEffectNode.active = true
            this.effectCtr.playEffectAnim(EffectName.SelfLose)
        }
        self.scheduleOnce(function () {
            self.winLoseNode.active = false
            self.winEffectNode.active = false
            self.loseEffectNode.active = false
            EventManager.instance.dispatch("Game_Table_Settlement", self.playerItems[self.selfPosIndex].Obj)
        }, 2)

        for (const key in this.betArea) {
            if (this.betArea.hasOwnProperty(key)) {
                const element = this.betArea[key];
                this.hideBetAreaCount(element)
                this.betCounts[key] = 0
            }
        }
    }

    protected hideBetAreaCount(area) {
        area.CountNode.active = false
        if (area.ResultObj != null) {
            area.ResultObj.node.active = false
        }
    }

    getCurrentJettons(count, parentNode, betlist): Array<cc.Sprite> {
        count = Math.floor(count)
        let itemTable = new Array<cc.Sprite>()
        if (count <= 0) { return itemTable }

        for (let index = 1; index <= this.jettonDatas.length; index++) {
            const jetton = this.jettonDatas[this.jettonDatas.length - index];
            if (jetton <= count) {
                for (const areaType in betlist) {
                    if (betlist.hasOwnProperty(areaType) && areaType == jetton) {
                        for (const key in betlist[areaType]) {
                            if (betlist[areaType].hasOwnProperty(key)) {
                                const betJetton = betlist[areaType][key];
                                if (jetton > count) {
                                    break
                                }
                                itemTable.push(betJetton)
                                count -= jetton
                                betlist[jetton].splice(key, 1)
                                if (count <= 0) {
                                    return itemTable
                                }
                            }
                        }
                    }
                }
            }
        }

        //牌桌上已经找不开筹码 或者没有了 生成一些
        for (let index = 1; index <= this.jettonDatas.length; index++) {
            while (this.jettonDatas[this.jettonDatas.length - index] <= count) {
                count = count - this.jettonDatas[this.jettonDatas.length - index]
                let countType = this.isFreeGame ? 0 : this.jettonDatas[this.jettonDatas.length - index]
                let o = this.jettonPool.getNode(countType)
                let sprIndex = (this.betTypeByIndex[this.jettonDatas[this.jettonDatas.length - index]]) + 1
                o.spriteFrame = this.isFreeGame ? this.goldSpr : this.jettonAtlas.getSpriteFrame("chouma0" + sprIndex)
                o.node.parent = parentNode
                o.node.position = new cc.Vec3(0, 0, 0)
                o.node.active = true
                let betType = this.jettonDatas[this.jettonDatas.length - index]
                o.node.name = (betType).toString()
                itemTable.push(o)
                if (this.betjettons[betType] == null) {
                    this.betjettons[betType] = new Array<cc.Sprite>()
                }
                this.betjettons[betType].push(o)
                if (count <= 0) {
                    return itemTable
                }
            }
        }
        return itemTable
    }

    //播放下注动画 其他人得
    playOtherBetAmin(otherData: any, isPlay: boolean, isPlaySound: boolean) {
        if (otherData == null) { return }
        let m_isPlaySound = !isPlaySound && isPlay

        for (const item of otherData) {
            if (item.data != null) {
                for (const otherBet of item.data) {
                    if (otherBet.count != null && otherBet.count > 0) {
                        if (m_isPlaySound) {
                            m_isPlaySound = false
                            this.tableSound.playBet(false)
                        }
                        this.flyBetAmin(otherBet, item.area, this.playerItems[this.othersPosIndex].StartPos.position, isPlay, this.playerItems[this.othersPosIndex].StartPos, null)
                    }
                }
            }
        }
        this.isShowPlay = []
    }

    //播放下注动画 排行榜玩家的
    playBetAmin(betData: any, isMySelf: boolean, otherBetData: any) {
        if (betData == null && betData.data == null) { return }
        let self = this
        function getPlay(index) {
            if (self.isShowPlayerIndex[index] == null) { return }
            let showid = self.isShowPlayerIndex[index].Id
            if (showid == betData.id && self.isShowPlay[showid] == null) {
                self.isShowPlay[showid] = betData
                let o = self.isShowPlayerIndex[index].Obj
                //处理下注数据
                for (const itemData of betData.data) {
                    if (itemData.data != null) {
                        for (const bet of itemData.data) {
                            if (bet.count != null || bet.count > 0) {
                                if (index != self.selfPosIndex) {
                                    self.flyBetAmin(bet, itemData.area, o.position, true, o, null)
                                }
                                for (const otherArea of otherBetData) {
                                    if (otherArea.area == itemData.area) {
                                        for (const otherBet of otherArea.data) {
                                            if (otherBet.type == bet.type) {
                                                otherBet.count = otherBet.count - bet.count
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        if (isMySelf) {
            getPlay(self.selfPosIndex)
        }
        else {
            for (let index = 0; index < this.isShowPlayerIndex.length; index++) {
                getPlay(index)
            }
        }
    }


    //播放自己的下注动画 本地的 未经过服务器校验
    //动画 下注 已经自身的金币都需要先本地更新 后面有服务器再校验
    playBetSelfAmin(bet, area, index, goldCount) {
        let betData = {
            count: 1,
            type: bet,
            obj: null,
            area: area
        }
        let startPos = this.playerItems[this.selfPosIndex].StartPos
        let o = this.flyBetAmin(betData, area, startPos.position, true, startPos, null)
        for (const key in this.isShowPlayerIndex) {
            if (this.isShowPlayerIndex.hasOwnProperty(key)) {
                const element = this.isShowPlayerIndex[key];
                if (element.isMySelf) {
                    element.Money.string = GameUtil.currencyFormatting(goldCount)
                }

            }
        }
        this.betCounts[area] = this.betCounts[area] + bet
        this.betArea[area].CountLab.string = GameUtil.currencyFormatting(this.betCounts[area])
        this.betArea[area].CountNode.active = this.betCounts[area] > 0
        betData.obj = o
        this.betDataByIndex[index] = betData
        this.tableSound.playBet(true)

        this.eventDispatch("refresh_multiple_gold", goldCount);
    }


    //下注失败找回一个
    playBetDefeated(index, goldCount) {
        let self = this
        let betData = this.betDataByIndex[index]
        if (betData == null) { return }
        this.betCounts[betData.area] = this.betCounts[betData.area] - betData.type
        this.betArea[betData.area].CountLab.string = GameUtil.currencyFormatting(this.betCounts[betData.area])
        this.betArea[betData.area].CountNode.active = this.betCounts[betData.area] > 0
        for (const key in this.isShowPlayerIndex) {
            if (this.isShowPlayerIndex.hasOwnProperty(key)) {
                const element = this.isShowPlayerIndex[key];
                if (element.isMySelf) {
                    element.Money.string = GameUtil.currencyFormatting(goldCount)
                }

            }
        }
        this.moveToArea(betData.obj.node, this.playerItems[this.selfPosIndex].StartPos, () => {
            betData.obj.node.active = false
        })
        this.betDataByIndex[index].count = 0
    }

    getRandomPosInRect(maxX, maxY): cc.Vec2 {
        var x = Math.random() * (Math.random() > 0.5 ? 1 : -1) * maxX
        var y = Math.random() * (Math.random() > 0.5 ? 1 : -1) * maxY
        return new cc.Vec2(x, y);
    }

    //获取下注区域 注意 这里鱼虾蟹和骰宝不一样
    getAreaByPosMax(area) {
        let pos = new cc.Vec2(0, 0);
        if (!this.isTb) {
            if (area <= 6) {
                pos = this.getRandomPosInRect(80, 80)
            }
            else if (area == 13 || area == 16 || area == 15 || area == 35 || area == 24 || area == 34 || area == 26 || area == 46) {
                pos = this.getRandomPosInRect(20, 20)
            }
            else if (area == 12 || area == 23 || area == 45 || area == 56) {
                pos = this.getRandomPosInRect(0, 80)
            }
            else if (area == 14 || area == 25 || area == 36) {

                pos = this.getRandomPosInRect(80, 0)
            }
        }
        else {
            if (area <= 7 || area == 9) {
                pos = this.getRandomPosInRect(50, 50)
            }
            else if (area == 8 || area == 57 || area == 67) {
                pos = this.getRandomPosInRect(50, 10)
            }
            else if (area == 14 || area == 16 || area == 25 || area == 26) {
                pos = this.getRandomPosInRect(10, 30)
            }
            else if (area == 123 || area == 36 || area == 24 || area == 35 || area == 15 || area == 456) {
                pos = this.getRandomPosInRect(30, 10)
            }
            else if (area == 23 || area == 34 || area == 45 || area == 17 || area == 69) {
                pos = this.getRandomPosInRect(0, 50)
            }
            else if (area == 12 || area == 37 || area == 47 || area == 56) {
                pos = this.getRandomPosInRect(50, 0)
            }
        }

        return pos
    }


    //飞筹码动画
    flyBetAmin(bet: any, area: number, startPos: cc.Vec2, isPlay: boolean, startNode: cc.Node, endNode: cc.Node): cc.Sprite {
        if (this.betArea[area].Obj == null) { return }
        let self = this
        startPos = this.node.convertToWorldSpaceAR(startPos)
        startPos = this.betArea[area].Obj.convertToNodeSpaceAR(startPos)
        let o = null
        for (let index = 0; index < bet.count; index++) {
            let countType = this.isFreeGame ? 0 : bet.type
            o = this.jettonPool.getNode(countType)
            let sprIndex = this.betTypeByIndex[bet.type] + 1
            o.spriteFrame = this.isFreeGame ? this.goldSpr : this.jettonAtlas.getSpriteFrame("chouma0" + sprIndex)
            o.node.parent = this.betArea[area].Obj
            o.node.angle = Math.random() * 360
            o.node.name = bet.type.toString()
            let pos = this.getAreaByPosMax(area)
            o.node.active = true
            if (this.betjettons[bet.type] == null) {
                this.betjettons[bet.type] = new Array<cc.Sprite>()
            }
            self.betjettons[bet.type].push(o)
            if (isPlay) {
                this.moveToPos(startPos, pos, o.node, null, 0.4)
            }
            else {
                o.node.position = pos
            }

        }
        return o //为了自己下筹码用到而已

    }

    moveToPos(startPos, endPos, NodeObj: cc.Node, callBack, time) {
        NodeObj.position = startPos
        var action = cc.moveTo(time, endPos).easing(cc.easeExponentialOut())
        NodeObj.runAction(cc.sequence(action, cc.callFunc(callBack)))
    }

    //清理牌桌
    cleanTable() {
        for (const iterator of this.playerItems) {
            iterator.Win.string = ""
        }
        this.bankerLoseLab.string = ""
        this.bankerWinLab.string = ""
        this.winEffectNode.active = false
        this.loseEffectNode.active = false
        this.isShowPlay.length = 0
        this.winJettonsById.length = 0
        this.betjettons.length = 0
        this.unscheduleAllCallbacks()
    }




    hidePlayerItem() {
        for (const key in this.playerItems) {
            if (this.playerItems.hasOwnProperty(key)) {
                const element = this.playerItems[key];
                if (this.isShowPlayerIndex[key] == null && element.PlayerInfo != null) {
                    element.PlayerInfo.active = false
                    element.NoPlayer.active = true
                    element.Name.string = ""
                    element.Money.string = ""
                }
            }
        }
    }




    playResultAmin(resuletData, betData, jackpotDataAdd) {
        if (betData == null) { return }
        let self = this
        let areaList = []
        let resultAreaData = [] //赢得区域筹码
        //先对结果排序
        let min
        for (var i = 0; i < resuletData.dice.length; i++) {
            for (var j = i; j < resuletData.dice.length; j++) {
                if (resuletData.dice[i].number > resuletData.dice[j].number) {
                    min = resuletData.dice[j]
                    resuletData.dice[j] = resuletData.dice[i]
                    resuletData.dice[i] = min
                }
            }
        }
        //计算赢区
        let totleCount = 0
        //骰宝才需要做特殊处理
        if (this.isTb) {
            for (let i = 0; i < 3; i++) {
                totleCount += resuletData.dice[i].number
            }
            if (totleCount < 11) {
                areaList["7"] = 1
            }
            else if (totleCount == 11) {
                areaList["8"] = 8
            }
            else {
                areaList["9"] = 1
            }
        }





        for (let i = 0; i < 3; i++) {
            areaList[resuletData.dice[i].number] = areaList[resuletData.dice[i].number] == null ? 1 : areaList[resuletData.dice[i].number] + 1
            if (this.isTb) {
                let tempKey = null
                if (totleCount < 11) {
                    if (resuletData.dice[i].number == 1 || resuletData.dice[i].number == 3) {
                        tempKey = resuletData.dice[i].number.toString() + "7"
                        areaList[tempKey] = areaList[tempKey] == null ? 1 : areaList[tempKey] + 1
                    }
                    else if (resuletData.dice[i].number == 5 || resuletData.dice[i].number == 6) {
                        tempKey = resuletData.dice[i].number.toString() + "7"
                        areaList[tempKey] = areaList[tempKey] == null ? 1 : areaList[tempKey] + 1
                    }
                }
                else if (totleCount > 11) {
                    if (resuletData.dice[i].number == 4 || resuletData.dice[i].number == 6) {
                        tempKey = resuletData.dice[i].number.toString() + "9"
                        areaList[tempKey] = areaList[tempKey] == null ? 1 : areaList[tempKey] + 1
                    }
                }
            }



            for (let j = i + 1; j < 3; j++) {
                if (resuletData.dice[i].number != resuletData.dice[j].number) {
                    let areaStr = resuletData.dice[i].number.toString() + resuletData.dice[j].number
                    if (this.isTb) {
                        if (Number(areaStr) == 13) {
                            areaStr = "123"
                        }

                        if (Number(areaStr) == 46) {
                            areaStr = "456"
                        }
                    }

                    areaList[areaStr] = 5
                }

            }
        }



        for (const areaStr in areaList) {
            if (areaList.hasOwnProperty(areaStr)) {
                if (areaList[areaStr] != null) {
                    let resultAmin = this.betArea[areaStr].ResultObj
                    if (resultAmin != null) {
                        resultAmin.node.active = true
                        resultAmin.play()
                        self.scheduleOnce(() => {
                            resultAmin.node.active = false
                        }, 3)
                    }
                }
            }
        }

        // this.curWinArea = this.betArea[area].Obj
        //第一阶段， 除去赢得区域 其他区域 往庄家飞
        let isPlaySound = true
        let tempBetByType = []
        for (const key in this.betjettons) {
            if (this.betjettons.hasOwnProperty(key)) {
                const iterator = this.betjettons[key];
                for (const index in iterator) {

                    if (iterator.hasOwnProperty(index)) {
                        const obj = iterator[index];
                        if (obj.node.parent != null && areaList[obj.node.parent.name] == null) {
                            if (tempBetByType[obj.node.name] == null) {
                                tempBetByType[obj.node.name] = new Array<cc.Sprite>()
                            }
                            tempBetByType[obj.node.name].push(obj)
                            self.scheduleOnce(function () {
                                if (obj.node.parent != null) {
                                    if (isPlaySound) {
                                        this.tableSound.playBet(false)
                                        isPlaySound = false
                                    }
                                    let startPos = self.node.convertToWorldSpaceAR(self.bankerNode.position)
                                    let endPos = obj.node.parent.convertToNodeSpaceAR(startPos)
                                    self.moveToPos(obj.node.position, endPos, obj.node, () => {
                                    }, 0.5)
                                }

                            }, self.getRandom(1, 3) * 0.1)
                        }

                    }
                }
            }
        }

        //第二阶段， 庄家处筹码 往赢得区域飞（每个赢得区域单独计算 
        for (const areaStr in areaList) {
            if (areaList.hasOwnProperty(areaStr)) {
                for (const data of betData) {
                    if (data.area == areaStr && data.amount > 0) {
                        resultAreaData[areaStr] = self.getCurrentJettons(data.amount, self.bankerNode, tempBetByType)
                    }
                }
            }
        }
        let caichiBets = self.getCurrentJettons(jackpotDataAdd, self.bankerNode, tempBetByType)

        this.scheduleOnce(() => {
            isPlaySound = true
            //if (!self.isTb){
            for (const key in resultAreaData) {
                if (resultAreaData.hasOwnProperty(key) && self.betArea.hasOwnProperty(key)) {
                    const itemObjs = resultAreaData[key];
                    let endPos = this.getAreaByPosMax(key)
                    for (const obj of itemObjs) {
                        self.scheduleOnce(() => {
                            if (isPlaySound) {
                                this.tableSound.playBet(false)
                                isPlaySound = false
                            }
                            if (obj.node.parent == null) {
                                return
                            }
                            let pos = obj.node.parent.convertToWorldSpaceAR(obj.node.position)
                            obj.node.parent = self.betArea[key].Obj
                            obj.node.angle = Math.random() * 360
                            let startPos = self.betArea[key].Obj.convertToNodeSpaceAR(pos)
                            self.moveToPos(startPos, endPos, obj.node, null, 0.4)
                        }, self.getRandom(1, 3) * 0.1)
                    }
                }
            }

            for (const obj of caichiBets) {
                self.scheduleOnce(() => {
                    if (obj.node.parent == null) {
                        self.jettonPool.setNode(obj)
                        return
                    }
                    const effectObj = cc.find("anim_yxx_feichouma", obj.node)
                    if (effectObj != null) { effectObj.active = true }
                    self.moveToArea(obj.node, self.caiChiPos, () => {
                        if (effectObj != null) { effectObj.active = false }
                        //self.jettonPool.setNode(obj)
                        obj.node.active = false
                    })
                }, self.getRandom(1, 3) * 0.1)
            }

            //飞完赢家区域 庄家还有得话 直接回收 这里得 算彩池得
            for (const iterator of tempBetByType) {
                for (const key in iterator) {
                    if (iterator.hasOwnProperty(key)) {
                        const obj = iterator[key];
                        self.jettonPool.setNode(obj)
                    }
                }

            }
        }, 0.8)

        //第三阶段 往 排行榜玩家 彩池 其他玩家处飞筹码
        this.scheduleOnce(() => {
            isPlaySound = true
            //首先飞排行榜玩家
            for (const key in self.winJettonsById) {
                if (self.winJettonsById.hasOwnProperty(key) && self.startPosById.hasOwnProperty(key)) {
                    const itemObjs = self.winJettonsById[key];
                    for (const obj of itemObjs) {

                        self.scheduleOnce(() => {

                            if (obj.node.parent == null) {
                                self.jettonPool.setNode(obj)
                                return
                            }
                            if (isPlaySound) {
                                isPlaySound = false
                            }
                            self.moveToArea(obj.node, self.startPosById[key], () => { self.jettonPool.setNode(obj) })
                        }, self.getRandom(1, 3) * 0.1)
                    }
                }
            }



            //最后飞其他玩家和彩池
            for (const key in this.betjettons) {
                if (this.betjettons.hasOwnProperty(key)) {
                    const iterator = this.betjettons[key];
                    for (const index in iterator) {
                        if (iterator.hasOwnProperty(index)) {
                            const obj = iterator[index];
                            self.scheduleOnce(function () {
                                if (obj.node.parent == null) {
                                    self.jettonPool.setNode(obj)
                                    return
                                }
                                if (isPlaySound) {
                                    this.tableSound.playBet(false)
                                    isPlaySound = false
                                }
                                self.moveToArea(obj.node, this.playerItems[self.othersPosIndex].StartPos, () => {
                                    self.jettonPool.setNode(obj)
                                })
                            }, this.getRandom(1, 3) * 0.1)

                        }
                    }
                }
            }
        }, 1.5)
    }

    //获取一个范围随机
    getRandom(min, max) {
        var length = max - min + 1;
        var num = parseInt(Math.random() * (length) + max);
        return num;
    }

    //移动筹码到某个区域
    moveToArea(obj, newNode, callBack: Function = null) {
        if (obj.parent == null || newNode == null) { return }
        let endPos = this.getRandomPosInRect(15, -15)
        endPos = newNode.convertToWorldSpaceAR(endPos)
        endPos = obj.parent.convertToNodeSpaceAR(endPos)
        this.moveToPos(obj.position, endPos, obj, callBack, 0.8)
    }


    //打赏庄家
    giveReward() {
        this.effectCtr.playEffectAnim(EffectName.HeGuanFeiWen, () => {
            this.effectCtr.playEffectAnim(EffectName.HeGuan, null, true)
        }, true)
        this.effectCtr.playEffectAnim(EffectName.FeiWen)
        this.effectCtr.playEffectAnim(EffectName.Wen)
    }

    //播放准备动画
    playReadyAmin(isPlay) {
        if (isPlay) {
            this.effectCtr.playEffectAnim(EffectName.Ready, null, true)
            this.tableSound.playYaoGu()
        }
    }

    //更新上下庄按钮信息
    updateBankerBtn(isWaitBanker: boolean, isClose) {
        this.goBankerBtn.active = isWaitBanker
        this.closeGoBankerBtn.active = isClose
    }

    updateBanker(userId, bankerData) {
        let self = this
        this.banker.active = true
        this.sysBanker.active = false
        this.sysYiZi.active = false
        self.bankerLoseLab.string = ""
        self.bankerWinLab.string = ""
        this.bankerRound.string = LanguageManager.t("lhd_juShu").format(bankerData.banker.round == null ? 1 : bankerData.banker.round);
        UserDataManager.setUserJsonData(bankerData.banker.userData)
        this.getUserData(userId, (data: IUserData) => {
            self.bankerName.string = GameUtil.cutStr(data.name)
            self.bankerHead.spriteFrame = data.avatarSprite
            if (self.lastBankerId == null || self.lastBankerId != userId) {
                self.lastBankerId = userId
                self.tipsBankerName.string = data.name
                self.tipsBankerIcon.spriteFrame = data.avatarSprite
                self.tipsBankerNode.active = true
                //播放新庄家提示
                self.scheduleOnce(() => {
                    self.tipsBankerNode.active = false
                }, 4.5)
            }
        })
        this.bankerGold.string = GameUtil.currencyFormatting(Number(bankerData.banker.balance))
        if (bankerData.winLoss != null && bankerData.winLoss != '') {
            let winNum = Number(bankerData.winLoss)
            self.scheduleOnce(function () {
                if (winNum >= 0) {
                    let winStr = "+" + GameUtil.currencyFormatting(winNum)
                    self.bankerWinLab.string = winStr
                    self.bankerLoseLab.string = ""
                }
                else {
                    self.bankerWinLab.string = ""
                    self.bankerLoseLab.string = GameUtil.currencyFormatting(winNum)
                }
                self.bankerWinLose.play()
            }, 1.3)
        }
    }


}